// All translatable content. Non-translatable data (URLs, dates, IBAN) is kept here only once.
const SHARED = {
  date: new Date("2026-09-26T17:00:00+02:00"),
  dateLabel: "26 . 09 . 2026",
  rsvpUrl: "https://americansocks.typeform.com/to/x4BHmQzA",
  poster:
    "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/73sr0th8_WhatsApp%20Image%202026-06-09%20at%2019.53.44.jpeg",
  logo:
    "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/316pss40_Gemini_Generated_Image_xe98raxe98raxe98-removebg-preview.png",
  mapsUrl:
    "https://www.google.com/maps/place/Mas%C3%ADa+San+Antonio/@41.2098228,1.6283358,17z/data=!3m1!4b1!4m6!3m5!1s0x12a389189142445b:0xadedc4f46e714e2d!8m2!3d41.2098228!4d1.6309107!16s%2Fg%2F11_yldd43",
  iban: "ES94 2100 0384 3102 0120 9613",
  revolut: "@wojtekburek",
  venueImage:
    "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,fit=crop/2pzdxMEFtGWugPLU/1690526116266-01_1_43541-169140481587653-ASwip019XPl8K2bW.webp",
};

const STORY_MEDIA = [
  // 01
  {
    img: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=900,fit=crop/2pzdxMEFtGWugPLU/c2da6db5-539f-457e-9436-03ede555966f-zvf2trFjD47FkeRg.jpg",
  },
  // 02
  {
    img: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,fit=crop/2pzdxMEFtGWugPLU/maragdamuntanei_wojtekariadna-21-IJsBbS0OcYLFvntD.jpg",
    gallery: [
      "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,fit=crop/2pzdxMEFtGWugPLU/maragdamuntanei_wojtekariadna-21-IJsBbS0OcYLFvntD.jpg",
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/m91uyqym_SaveClip.App_650061403_18100218736741452_6445084369926088552_n.jpg",
    ],
  },
  // 03 - NEW "Fets l'un per l'altre"
  {
    img: "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/ytik1v84_SaveClip.App_650138902_18075297677389280_2709826785314434055_n.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/ytik1v84_SaveClip.App_650138902_18075297677389280_2709826785314434055_n.jpg",
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/92gtzlng_SaveClip.App_647344019_18054823415686680_1521999949614918400_n.jpg",
    ],
  },
  // 04 - Dos culs inquiets (gallery)
  {
    img: "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/lipg6o32_533e1f3c-b3f6-4765-9b1e-510ce99def7f.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/lipg6o32_533e1f3c-b3f6-4765-9b1e-510ce99def7f.jpg",
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/u3kg6vlw_1.jpg",
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/uaxa5wxj_2.jpg",
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/iycnrm74_3.jpg",
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/7r91610m_4.jpg",
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/9n8tvxrt_5.jpg",
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/nmludf56_6.jpg",
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/blaco9bl_7.jpg",
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/4t3cmaoj_8.jpg",
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/4n1uoix4_9.jpg",
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/nxf68qt0_10.jpg",
    ],
  },
  // 05 - Las Vegas (with video)
  {
    img: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,h=919,fit=crop/2pzdxMEFtGWugPLU/img_7232-oNyywq2vlcpHmSHp.JPG",
    video:
      "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/eqzzwq28_Sin%20ti%CC%81tulo%20%281%29.mov",
  },
  // 06 - Official
  {
    img: "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/ekn6jdz8_MaragdaMuntane%CC%81_WojtekAriadna-55.jpg",
  },
  // 07 - Rock n Roll
  {
    img: "https://customer-assets.emergentagent.com/job_ariadna-big-day/artifacts/pxnobfxn_MaragdaMuntane%CC%81_WojtekAriadna-40.jpg",
  },
];

const HOTEL_DATA = [
  {
    nameKey: "h1",
    stars: 2,
    link: "https://www.booking.com/hotel/es/sant-jordi-segur-de-calafell.ca.html?checkin=2026-09-26&checkout=2026-09-27&group_adults=2&no_rooms=1&group_children=0",
    img: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=600,h=600,fit=crop/2pzdxMEFtGWugPLU/149015508-WWaKVqGSWytcCsM5.jpg",
  },
  {
    nameKey: "h2",
    stars: 3,
    link: "https://www.booking.com/hotel/es/adia-cunit-playa.ca.html?checkin=2026-09-26&checkout=2026-09-27&group_adults=2&no_rooms=1&group_children=0",
    img: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=600,h=600,fit=crop/2pzdxMEFtGWugPLU/831456689-w8IxzWRom0ti8J7e.jpg",
    deal: {
      rooms: [
        { typeKey: "double", price: "96€", tax: "+1,32€" },
        { typeKey: "single", price: "76€", tax: "+0,66€" },
        { typeKey: "triple", price: "132€", tax: "+1,98€" },
      ],
      lateCheckout: "15:00h",
      lateCheckoutFee: "15€",
    },
  },
  {
    nameKey: "h3",
    stars: 4,
    link: "https://www.booking.com/hotel/es/canada-palace.ca.html?checkin=2026-09-26&checkout=2026-09-27&group_adults=2&no_rooms=1&group_children=0",
    img: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=600,h=600,fit=crop/2pzdxMEFtGWugPLU/262168938-uyvEnAcOU20ADohS.jpg",
  },
];

const T = {
  ca: {
    nav: {
      story: "Història",
      info: "Informació",
      stay: "Allotjament",
      schedule: "Horaris",
      gift: "Regal",
      rsvp: "Confirma",
      rsvpFull: "Confirmar assistència",
      openMenu: "Obrir menú",
      closeMenu: "Tancar menú",
    },
    hero: {
      metaPlace: "✱ Masia San Antonio · Cunit",
      metaEdition: "Edició Única · 2026 ✱",
      stickerLove: "Till death, baby",
      stickerRock: "Rock n Roll Wedding",
      labelDate: "✱ Data",
      labelPlace: "✱ Lloc",
      longDate: "Dissabte 26 de Setembre de 2026",
      venue: "Masia San Antonio",
      venueCity: "Cunit · Tarragona",
      cta: "Confirmar assistència",
    },
    countdown: {
      eyebrow: "✱ Des de la festa",
      title: "La ressaca encara dura",
      days: "Dies",
      hours: "Hores",
      minutes: "Minuts",
      seconds: "Segons",
    },
    albums: {
      eyebrow: "Àlbums de la boda",
      title: "Reviu el dia",
      titleAccent: "al complet",
      lead: "Les fotos oficials ja estan aquí. Entra a cada àlbum per veure-ho tot a Google Photos.",
      cta: "Veure àlbum",
      footnote: "Vols afegir les teves fotos i vídeos? Puja-les al Dropbox que us vam enviar per correu 🖤",
      items: {
        pre:       { title: "Pre-cerimònia",         subtitle: "Els preparatius" },
        cerimonia: { title: "Cerimònia",             subtitle: "El \"sí, vull\"" },
        cocktail:  { title: "Còctel",                subtitle: "Pica-pica al jardí" },
        sopar:     { title: "Sopar",                 subtitle: "A taula amb la gent" },
        festa:     { title: "Festa",                 subtitle: "Fins que es faci de dia" },
        toni:      { title: "Festa by Toni Villen",  subtitle: "Vista de l'amic Toni" },
        analog:    { title: "Fotos analògiques",     subtitle: "Càmeres d'un sol ús" },
      },
    },
    marquee1: "This is how we roll",
    marquee2: "Ariadna & Wojtek · 26.09.2026",
    story: {
      eyebrow: "Cara A · El nostre camí",
      titlePre: "Com",
      titleMid: "hem",
      titleEnd: "arribat fins aquí",
      tracklist: "Tracklist",
      capPrefix: "Cap.",
      items: [
        {
          eyebrow: "Cap. 01",
          title: "Ens vam conèixer per casualitat",
          text: "Entre concerts, amics i alguna festa.",
        },
        {
          eyebrow: "Cap. 02",
          title: "Poc a poc",
          text: "Vam anar descobrint que tenim més coses en comú de les que ens pensàvem.",
        },
        {
          eyebrow: "Cap. 03",
          title: "I és que estem fets l'un per l'altre",
          text: "",
        },
        {
          eyebrow: "Cap. 04",
          title: "Som dos culs inquiets",
          text: "Que volen descobrir tot el món envoltats de la millor companyia, tots vosaltres, que hi sou des del principi.",
        },
        {
          eyebrow: "Cap. 05",
          title: "Tot i que ja ens vam casar en secret a Las Vegas",
          text: "I sí, amb l'Elvis Presley.",
        },
        {
          eyebrow: "Cap. 06",
          title: "El 26 de Setembre ens acompanyareu a fer-ho oficial",
          text: "",
        },
        {
          eyebrow: "Cap. 07",
          title: "I ho farem, com no podia ser d'altra manera",
          text: "Amb molt de Rock n Roll.",
          highlight: true,
        },
      ],
    },
    info: {
      eyebrow: "✱ Cara B · Informació clau",
      titleA: "Tota la info",
      titleB: "del gran dia",
      intro:
        "Anota't aquesta data al calendari, prepara el millor look i vine amb les ganes posades. T'expliquem com arribar i tot el que cal saber.",
      lblDate: "✱ Data",
      lblPlace: "✱ Lloc",
      lblParking: "✱ Pàrquing",
      dateBig: "26 de Setembre de 2026",
      dateSub: "Dissabte · des de les 17:00",
      venue: "Masia San Antonio",
      address: "Ctra. Cunit a Clariana, 43881 Cunit, Tarragona",
      parking:
        "La masia disposa d'aparcament propi, així que podeu venir amb cotxe sense problema. Recomanem compartir vehicle sempre que sigui possible.",
      cta: "Porta'm-hi",
      mapLabel: "Veure al mapa",
    },
    schedule: {
      eyebrow: "Setlist · Horaris",
      titleA: "El",
      titleAccent: "directe",
      subtitle: "Arribeu puntuals si no us voleu perdre res!",
      items: [
        { time: "16:50", event: "Recollida a Hotel Canadà Palace", note: "Av. Mossèn Jaume Soler, 44 · Calafell" },
        { time: "17:00", event: "Recollida a Hotel Sant Jordi", note: "C/ del Xúquer, 24 · Segur de Calafell" },
        { time: "17:10", event: "Recollida a Hotel Adaia Cunit", note: "Av. Tarragona, 2 · Cunit" },
        { time: "17:30", event: "Arribada a Masia Sant Antoni", note: "Es descarrega a la porta d'accés · l'autocar no accedeix dins la Masia" },
        { time: "18:00", event: "Cerimònia", note: "El moment clau" },
        { time: "20:30", event: "Sopar", note: "Brindis & bona companyia" },
        { time: "23:00", event: "Festa", note: "Fins que el cos aguanti" },
        { time: "02:00", event: "Shuttle furgonetes als hotels", note: "Fins les 04:00 · cada 30 min" },
        { time: "05:00", event: "Bus tornada als hotels", note: "No espera · sigueu puntuals!" },
      ],
    },
    dress: {
      eyebrow: "✱ Codi de vestuari",
      titleA: "Clàssic &",
      titleB: "Rock n Roll",
      text: "Clàssic i arreglat. Ens agradaria que vinguéssiu elegants, còmodes i sent vosaltres mateixos… amb molt de Rock n Roll. Recordeu que part de la celebració serà a l'exterior.",
      tags: ["Elegant", "Còmode", "Festiu", "Rock n Roll"],
    },
    kidless: {
      eyebrow: "✱ Aviso · per pares i mares",
      title: "Kid·Less",
      text: "És un casament de nit i promovem que sigui Kid-Less. Tot i que els nens són benvinguts, per l'horari i el tipus de celebració creiem que pot ser un bon dia per deixar-los a casa i gaudir de la festa amb tranquil·litat. Gràcies per entendre-ho ♥",
    },
    hotels: {
      eyebrow: "✱ Allotjament · Reserveu aviat",
      titleA: "On",
      titleAccent: "dormir",
      titleB: "quan s'acabi la festa",
      intro:
        "Com que el casament se celebra a finals d'estiu, us recomanem reservar allotjament com més aviat millor. Hi haurà ",
      introBold: "shuttle des de la masia fins als hotels",
      introTail: " amb sortides des de les 02:00. Si teniu dubtes o necessiteu ajuda per reservar, ens podeu escriure.",
      distancePrefix: "",
      distanceSuffix: "km del casament",
      bookCta: "Reservar a Booking",
      dealBadge: "Oferta especial",
      dealTitle: "Preus exclusius pels convidats",
      dealRoomDouble: "Doble",
      dealRoomSingle: "Individual",
      dealRoomTriple: "Triple",
      dealTaxNote: "+ taxa turística",
      dealLateCheckout: "Late check-out fins a les",
      dealLateCheckoutFee: "amb suplement de",
      dealLateCheckoutFeeSuffix: "per habitació",
      h1: "Hotel Sant Jordi",
      h1d: "2,6",
      h2: "Adia Hotel Cunit",
      h2d: "2,3",
      h3: "Hotel Canada Palace",
      h3d: "5",
    },
    gift: {
      eyebrow: "✱ Detall · Regal",
      titleA: "Si us ve",
      titleB: "de gust...",
      intro:
        "El més important per a nosaltres és compartir aquest dia amb vosaltres. Però si, a més, us ve de gust fer-nos un regal, aquest anirà destinat a un viatge de noses d'ensomni.",
      lblIban: "Transferència · IBAN",
      lblRevolut: "Revolut",
      lblCash: "Efectiu",
      cashText: "Entregar el dia de la cerimònia a l'Olek.",
      copy: "Copiar",
      copied: "Copiat",
    },
    finalCta: {
      eyebrow: "✱ T'esperem",
      titleA: "Ens hi",
      titleB: "acompanyes?",
      intro: "Si us plau, confirma la teva assistència abans del ",
      deadline: "1 d'agost de 2026",
      introTail: ". Així ens ajudes a organitzar-ho tot amb temps.",
      cta: "Confirmar assistència",
    },
    footer: {
      tagline: "Ens veiem el 26 · 09 · 2026",
      place: "Masia San Antonio · Cunit · Tarragona",
    },
  },

  en: {
    nav: {
      story: "Story",
      info: "Info",
      stay: "Stay",
      schedule: "Schedule",
      gift: "Gift",
      rsvp: "RSVP",
      rsvpFull: "Confirm attendance",
      openMenu: "Open menu",
      closeMenu: "Close menu",
    },
    hero: {
      metaPlace: "✱ Masia San Antonio · Cunit",
      metaEdition: "One-Night-Only Edition · 2026 ✱",
      stickerLove: "Till death, baby",
      stickerRock: "Rock n Roll Wedding",
      labelDate: "✱ Date",
      labelPlace: "✱ Venue",
      longDate: "Saturday, September 26th, 2026",
      venue: "Masia San Antonio",
      venueCity: "Cunit · Tarragona",
      cta: "Confirm attendance",
    },
    countdown: {
      eyebrow: "✱ Since the party",
      title: "The hangover isn't over yet",
      days: "Days",
      hours: "Hours",
      minutes: "Minutes",
      seconds: "Seconds",
    },
    albums: {
      eyebrow: "Wedding albums",
      title: "Relive the day",
      titleAccent: "in full",
      lead: "The official photos are here. Open each album to see everything on Google Photos.",
      cta: "View album",
      footnote: "Want to share your own photos and videos? Upload them to the Dropbox we emailed you 🖤",
      items: {
        pre:       { title: "Pre-ceremony",            subtitle: "Getting ready" },
        cerimonia: { title: "Ceremony",                subtitle: "The \"I do\"" },
        cocktail:  { title: "Cocktail",                subtitle: "Appetizers in the garden" },
        sopar:     { title: "Dinner",                  subtitle: "Everyone at the table" },
        festa:     { title: "Party",                   subtitle: "Until sunrise" },
        toni:      { title: "Party by Toni Villen",    subtitle: "Through our friend's lens" },
        analog:    { title: "Analog photos",           subtitle: "Disposable cameras" },
      },
    },
    marquee1: "This is how we roll",
    marquee2: "Ariadna & Wojtek · 26.09.2026",
    story: {
      eyebrow: "Side A · How we got here",
      titlePre: "How",
      titleMid: "we got",
      titleEnd: "here",
      tracklist: "Tracklist",
      capPrefix: "Ch.",
      items: [
        {
          eyebrow: "Ch. 01",
          title: "We met by chance",
          text: "Among concerts, friends and a party or two.",
        },
        {
          eyebrow: "Ch. 02",
          title: "Little by little",
          text: "We discovered we had way more in common than we thought.",
        },
        {
          eyebrow: "Ch. 03",
          title: "We're simply made for each other",
          text: "",
        },
        {
          eyebrow: "Ch. 04",
          title: "We're two restless souls",
          text: "Wanting to discover the whole world surrounded by the best company — all of you, here from day one.",
        },
        {
          eyebrow: "Ch. 05",
          title: "Even though we already got married in secret in Las Vegas",
          text: "And yes, with Elvis Presley.",
        },
        {
          eyebrow: "Ch. 06",
          title: "On September 26th you'll join us to make it official",
          text: "",
        },
        {
          eyebrow: "Ch. 07",
          title: "And we'll do it, how else could it be",
          text: "With a whole lot of Rock n Roll.",
          highlight: true,
        },
      ],
    },
    info: {
      eyebrow: "✱ Side B · The key info",
      titleA: "All the info",
      titleB: "for the big day",
      intro:
        "Save the date, pick your best outfit and bring all the good vibes. Here's how to get there and everything you need to know.",
      lblDate: "✱ Date",
      lblPlace: "✱ Venue",
      lblParking: "✱ Parking",
      dateBig: "September 26th, 2026",
      dateSub: "Saturday · from 5:00 pm",
      venue: "Masia San Antonio",
      address: "Ctra. Cunit a Clariana, 43881 Cunit, Tarragona",
      parking:
        "The venue has its own parking, so you can come by car no problem. We recommend carpooling whenever possible.",
      cta: "Take me there",
      mapLabel: "Open in maps",
    },
    schedule: {
      eyebrow: "Setlist · Schedule",
      titleA: "The",
      titleAccent: "live show",
      subtitle: "Be on time if you don't want to miss anything!",
      items: [
        { time: "16:50", event: "Pickup at Hotel Canadà Palace", note: "Av. Mossèn Jaume Soler, 44 · Calafell" },
        { time: "17:00", event: "Pickup at Hotel Sant Jordi", note: "C/ del Xúquer, 24 · Segur de Calafell" },
        { time: "17:10", event: "Pickup at Hotel Adaia Cunit", note: "Av. Tarragona, 2 · Cunit" },
        { time: "17:30", event: "Arrival at Masia Sant Antoni", note: "Drop-off at the entrance · the bus cannot access the venue" },
        { time: "18:00", event: "Ceremony", note: "The big moment" },
        { time: "20:30", event: "Dinner", note: "Toasts & good company" },
        { time: "23:00", event: "Party", note: "Until our bodies give in" },
        { time: "02:00", event: "Shuttle vans to hotels", note: "Until 4:00 · every 30 min" },
        { time: "05:00", event: "Return bus to hotels", note: "Won't wait · be on time!" },
      ],
    },
    dress: {
      eyebrow: "✱ Dress code",
      titleA: "Classic &",
      titleB: "Rock n Roll",
      text: "Classic and dressed up. We'd love to see you elegant, comfy and being yourselves… with lots of Rock n Roll. Keep in mind part of the celebration will be outdoors.",
      tags: ["Elegant", "Comfy", "Festive", "Rock n Roll"],
    },
    kidless: {
      eyebrow: "✱ Heads up · to parents",
      title: "Kid·Less",
      text: "This is a night wedding and we'd love it to be Kid-Less. Kids are welcome, but given the time and vibe of the celebration we think it might be a good day to leave them at home and enjoy the party stress-free. Thanks for understanding ♥",
    },
    hotels: {
      eyebrow: "✱ Stay · Book early",
      titleA: "Where to",
      titleAccent: "crash",
      titleB: "when the party's over",
      intro:
        "Since the wedding is at the end of summer, we recommend booking your stay as soon as possible. There'll be ",
      introBold: "a shuttle from the venue to the hotels",
      introTail: " departing from 2:00 am. If you have any doubts or need help booking, write to us.",
      distancePrefix: "",
      distanceSuffix: "km from the wedding",
      bookCta: "Book on Booking",
      dealBadge: "Special offer",
      dealTitle: "Exclusive prices for guests",
      dealRoomDouble: "Double",
      dealRoomSingle: "Single",
      dealRoomTriple: "Triple",
      dealTaxNote: "+ tourist tax",
      dealLateCheckout: "Late check-out until",
      dealLateCheckoutFee: "with a fee of",
      dealLateCheckoutFeeSuffix: "per room",
      h1: "Hotel Sant Jordi",
      h1d: "2.6",
      h2: "Adia Hotel Cunit",
      h2d: "2.3",
      h3: "Hotel Canada Palace",
      h3d: "5",
    },
    gift: {
      eyebrow: "✱ Detail · Gift",
      titleA: "If you",
      titleB: "feel like it...",
      intro:
        "What matters most to us is sharing this day with you. But if you also feel like giving us a gift, it'll go straight to a dreamy honeymoon trip.",
      lblIban: "Bank transfer · IBAN",
      lblRevolut: "Revolut",
      lblCash: "Cash",
      cashText: "Hand it to Olek on the wedding day.",
      copy: "Copy",
      copied: "Copied",
    },
    finalCta: {
      eyebrow: "✱ We're waiting",
      titleA: "Will you",
      titleB: "join us?",
      intro: "Please confirm your attendance before ",
      deadline: "August 1st, 2026",
      introTail: ". This way you help us plan everything in time.",
      cta: "Confirm attendance",
    },
    footer: {
      tagline: "See you on 26 · 09 · 2026",
      place: "Masia San Antonio · Cunit · Tarragona",
    },
  },

  pl: {
    nav: {
      story: "Historia",
      info: "Info",
      stay: "Nocleg",
      schedule: "Plan",
      gift: "Prezent",
      rsvp: "Potwierdź",
      rsvpFull: "Potwierdź obecność",
      openMenu: "Otwórz menu",
      closeMenu: "Zamknij menu",
    },
    hero: {
      metaPlace: "✱ Masia San Antonio · Cunit",
      metaEdition: "Edycja jednorazowa · 2026 ✱",
      stickerLove: "Till death, baby",
      stickerRock: "Rock n Roll Wedding",
      labelDate: "✱ Data",
      labelPlace: "✱ Miejsce",
      longDate: "Sobota, 26 września 2026",
      venue: "Masia San Antonio",
      venueCity: "Cunit · Tarragona",
      cta: "Potwierdź obecność",
    },
    countdown: {
      eyebrow: "✱ Od imprezy",
      title: "Kac wciąż trwa",
      days: "Dni",
      hours: "Godziny",
      minutes: "Minuty",
      seconds: "Sekundy",
    },
    albums: {
      eyebrow: "Albumy ze ślubu",
      title: "Przeżyj ten dzień",
      titleAccent: "jeszcze raz",
      lead: "Oficjalne zdjęcia są już dostępne. Otwórz każdy album, aby zobaczyć wszystko na Google Photos.",
      cta: "Zobacz album",
      footnote: "Chcesz dodać swoje zdjęcia i filmy? Wgraj je do Dropbox-a, który wysłaliśmy mailem 🖤",
      items: {
        pre:       { title: "Przed ceremonią",         subtitle: "Przygotowania" },
        cerimonia: { title: "Ceremonia",               subtitle: "To słynne \"tak\"" },
        cocktail:  { title: "Koktajl",                 subtitle: "Przystawki w ogrodzie" },
        sopar:     { title: "Kolacja",                 subtitle: "Wszyscy przy stole" },
        festa:     { title: "Impreza",                 subtitle: "Aż do świtu" },
        toni:      { title: "Impreza by Toni Villen",  subtitle: "Oczami przyjaciela Toniego" },
        analog:    { title: "Zdjęcia analogowe",       subtitle: "Aparaty jednorazowe" },
      },
    },
    marquee1: "This is how we roll",
    marquee2: "Ariadna & Wojtek · 26.09.2026",
    story: {
      eyebrow: "Strona A · Nasza droga",
      titlePre: "Jak",
      titleMid: "tu",
      titleEnd: "trafiliśmy",
      tracklist: "Tracklista",
      capPrefix: "Rozdz.",
      items: [
        {
          eyebrow: "Rozdz. 01",
          title: "Poznaliśmy się przypadkiem",
          text: "Wśród koncertów, znajomych i jakiejś imprezy.",
        },
        {
          eyebrow: "Rozdz. 02",
          title: "Powoli, powoli",
          text: "Zaczęliśmy odkrywać, że mamy ze sobą więcej wspólnego niż myśleliśmy.",
        },
        {
          eyebrow: "Rozdz. 03",
          title: "Bo po prostu jesteśmy dla siebie stworzeni",
          text: "",
        },
        {
          eyebrow: "Rozdz. 04",
          title: "Jesteśmy dwojgiem niespokojnych dusz",
          text: "Chcących odkryć cały świat w najlepszym towarzystwie — Was wszystkich, którzy jesteście z nami od początku.",
        },
        {
          eyebrow: "Rozdz. 05",
          title: "I chociaż już wzięliśmy potajemny ślub w Las Vegas",
          text: "I tak, z Elvisem Presleyem.",
        },
        {
          eyebrow: "Rozdz. 06",
          title: "26 września dołączycie do nas, by uczynić to oficjalnym",
          text: "",
        },
        {
          eyebrow: "Rozdz. 07",
          title: "I zrobimy to, jakżeby inaczej",
          text: "Z mnóstwem Rock n Roll.",
          highlight: true,
        },
      ],
    },
    info: {
      eyebrow: "✱ Strona B · Najważniejsze info",
      titleA: "Wszystko",
      titleB: "o naszym dniu",
      intro:
        "Zapisz datę w kalendarzu, przygotuj najlepszy strój i przyjedź z dobrą energią. Wyjaśniamy jak dotrzeć i wszystko, co warto wiedzieć.",
      lblDate: "✱ Data",
      lblPlace: "✱ Miejsce",
      lblParking: "✱ Parking",
      dateBig: "26 września 2026",
      dateSub: "Sobota · od godz. 17:00",
      venue: "Masia San Antonio",
      address: "Ctra. Cunit a Clariana, 43881 Cunit, Tarragona",
      parking:
        "Posiadłość ma własny parking, więc spokojnie możecie przyjechać samochodem. Polecamy podwózki, jeśli to możliwe.",
      cta: "Zabierz mnie tam",
      mapLabel: "Otwórz w mapach",
    },
    schedule: {
      eyebrow: "Setlista · Plan",
      titleA: "Występ",
      titleAccent: "na żywo",
      subtitle: "Przyjdźcie punktualnie, żeby niczego nie przegapić!",
      items: [
        { time: "16:50", event: "Odbiór z Hotel Canadà Palace", note: "Av. Mossèn Jaume Soler, 44 · Calafell" },
        { time: "17:00", event: "Odbiór z Hotel Sant Jordi", note: "C/ del Xúquer, 24 · Segur de Calafell" },
        { time: "17:10", event: "Odbiór z Hotel Adaia Cunit", note: "Av. Tarragona, 2 · Cunit" },
        { time: "17:30", event: "Przybycie do Masia Sant Antoni", note: "Wysiadamy przy wejściu · autokar nie wjedzie na teren" },
        { time: "18:00", event: "Ceremonia", note: "Kluczowy moment" },
        { time: "20:30", event: "Kolacja", note: "Toasty i dobre towarzystwo" },
        { time: "23:00", event: "Impreza", note: "Aż padniemy" },
        { time: "02:00", event: "Vany do hoteli", note: "Do 04:00 · co 30 minut" },
        { time: "05:00", event: "Autobus powrotny do hoteli", note: "Nie czeka · bądźcie punktualni!" },
      ],
    },
    dress: {
      eyebrow: "✱ Dress code",
      titleA: "Klasycznie &",
      titleB: "Rock n Roll",
      text: "Klasycznie i elegancko. Chcielibyśmy zobaczyć Was eleganckich, ale wygodnych — sobą… z mnóstwem Rock n Rolla. Pamiętajcie, że część uroczystości odbędzie się na zewnątrz.",
      tags: ["Elegancko", "Wygodnie", "Świątecznie", "Rock n Roll"],
    },
    kidless: {
      eyebrow: "✱ Uwaga · dla rodziców",
      title: "Kid·Less",
      text: "To wesele wieczorne i chcielibyśmy, by było Kid-Less. Dzieci są mile widziane, ale ze względu na godziny i charakter imprezy uważamy, że to dobry dzień, żeby zostawić je w domu i spokojnie się bawić. Dzięki za zrozumienie ♥",
    },
    hotels: {
      eyebrow: "✱ Nocleg · Rezerwujcie wcześnie",
      titleA: "Gdzie",
      titleAccent: "się przespać",
      titleB: "gdy impreza się skończy",
      intro:
        "Wesele odbędzie się pod koniec lata, dlatego polecamy zarezerwować nocleg jak najszybciej. Będzie ",
      introBold: "transport z posiadłości do hoteli",
      introTail: " z odjazdami od 02:00. Jeśli macie pytania lub potrzebujecie pomocy z rezerwacją, napiszcie do nas.",
      distancePrefix: "",
      distanceSuffix: "km od wesela",
      bookCta: "Zarezerwuj na Booking",
      dealBadge: "Oferta specjalna",
      dealTitle: "Ceny wyłącznie dla gości",
      dealRoomDouble: "Dwuosobowy",
      dealRoomSingle: "Jednoosobowy",
      dealRoomTriple: "Trzyosobowy",
      dealTaxNote: "+ opłata turystyczna",
      dealLateCheckout: "Późne wymeldowanie do",
      dealLateCheckoutFee: "z dopłatą",
      dealLateCheckoutFeeSuffix: "za pokój",
      h1: "Hotel Sant Jordi",
      h1d: "2,6",
      h2: "Adia Hotel Cunit",
      h2d: "2,3",
      h3: "Hotel Canada Palace",
      h3d: "5",
    },
    gift: {
      eyebrow: "✱ Detal · Prezent",
      titleA: "Jeśli macie",
      titleB: "ochotę...",
      intro:
        "Najważniejsze dla nas jest spędzenie tego dnia z Wami. Ale jeśli macie ochotę zrobić nam prezent, przeznaczymy go na podróż poślubną marzeń.",
      lblIban: "Przelew · IBAN",
      lblRevolut: "Revolut",
      lblCash: "Gotówka",
      cashText: "Wręczcie Olkowi w dniu ślubu.",
      copy: "Kopiuj",
      copied: "Skopiowano",
    },
    finalCta: {
      eyebrow: "✱ Czekamy",
      titleA: "Dołączysz",
      titleB: "do nas?",
      intro: "Prosimy o potwierdzenie obecności do ",
      deadline: "1 sierpnia 2026",
      introTail: ". Dzięki temu zdążymy wszystko zaplanować.",
      cta: "Potwierdź obecność",
    },
    footer: {
      tagline: "Do zobaczenia 26 · 09 · 2026",
      place: "Masia San Antonio · Cunit · Tarragona",
    },
  },
};

export const getContent = (lang) => {
  const t = T[lang] || T.ca;
  const storyItems = t.story.items.map((it, i) => ({
    ...it,
    ...(STORY_MEDIA[i] || {}),
  }));
  const hotels = HOTEL_DATA.map((h) => ({
    name: t.hotels[h.nameKey],
    distance: `${t.hotels.distancePrefix}${t.hotels[`${h.nameKey}d`]} ${t.hotels.distanceSuffix}`,
    stars: h.stars,
    link: h.link,
    img: h.img,
    deal: h.deal || null,
  }));
  return {
    ...SHARED,
    t,
    story: storyItems,
    hotels,
    location: {
      name: t.info.venue,
      address: t.info.address,
      link: SHARED.mapsUrl,
      parking: t.info.parking,
      image: SHARED.venueImage,
    },
    gift: {
      iban: SHARED.iban,
      revolut: SHARED.revolut,
      intro: t.gift.intro,
      cash: t.gift.cashText,
    },
  };
};

export const LANGS = [
  { code: "ca", label: "CA" },
  { code: "en", label: "EN" },
  { code: "pl", label: "PL" },
];
